export const classic = [
  {
    number: 'HC99',
    hasModel: false
  },
{
    number: 'HC100',
    hasModel: false
  },
  {
    number: 'HC101',
    hasModel: false
  },
  {
    number: 'HC102',
    hasModel: false
  },
  {
    number: 'HC103',
    hasModel: false
  },
  {
    number: 'HC104',
    hasModel: false
  },
  {
    number: 'HC105',
    hasModel: false
  },
  {
    number: 'HC106',
    hasModel: false
  },
  {
    number: 'HC107',
    hasModel: false
  },
  {
    number: 'HC108',
    hasModel: false
  },
  {
    number: 'HC109',
    hasModel: false
  },
  {
    number: 'HC110',
    hasModel: false
  },
  {
    number: 'HC111',
    hasModel: false
  },
  {
    number: 'HC112',
    hasModel: false
  },

]